"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderSingleInputValue = exports.renderMultiInputValue = exports.haveSameKeys = exports.getSelectedOptions = exports.getSelectedOption = exports.getOptionsList = exports.NO_GROUP_HEADER = exports.MRU_GROUP_KEY = void 0;
var _listboxUtils = require("../List/_listboxUtils");
var _isFunction = require("./isFunction");
const NO_GROUP_HEADER = exports.NO_GROUP_HEADER = '__NoGroupHeader__';
const MRU_GROUP_KEY = exports.MRU_GROUP_KEY = '__mruGroup__';
const getOptionsList = args => {
  var _a;
  const {
    options,
    mruOptions,
    groupBy,
    mruTitle,
    otherGroupHeader
  } = args;
  const newMruOptions = mruOptions === null || mruOptions === void 0 ? void 0 : mruOptions.map(option => Object.assign(Object.assign({}, option), {
    [(groupBy === null || groupBy === void 0 ? void 0 : groupBy.length) ? groupBy : MRU_GROUP_KEY]: mruTitle,
    isMru: true
  }));
  // put all options into a map with group as key
  const uniqueGroups = {};
  options === null || options === void 0 ? void 0 : options.forEach(eachOption => {
    const groupByEachOption = groupBy ? eachOption[groupBy] : null;
    const groupLabel = groupByEachOption || otherGroupHeader || NO_GROUP_HEADER;
    if (!uniqueGroups[groupLabel]) {
      uniqueGroups[groupLabel] = [];
    }
    uniqueGroups[groupLabel].push(eachOption);
  });
  const newOptions = [];
  if (newMruOptions === null || newMruOptions === void 0 ? void 0 : newMruOptions.length) {
    const mruOptionsGroup = [...newMruOptions];
    if (options === null || options === void 0 ? void 0 : options.length) {
      mruOptionsGroup.push({
        divider: true
      });
    }
    newOptions.push(mruOptionsGroup);
  }
  Object.keys(uniqueGroups).sort(groupHeader => groupHeader === NO_GROUP_HEADER ? -1 : 0).forEach((groupKey, index, array) => {
    const groupToPush = [...uniqueGroups[groupKey]];
    if (index < array.length - 1) {
      groupToPush.push({
        divider: true
      });
    }
    newOptions.push(groupToPush);
  });
  // one last sanity check
  // grouped list if:
  //   - `groupBy` is set
  //   - `otherGroupHeader` is set
  //   - `mruOptions` is set and not empty
  const isUsingGroups = !!groupBy || !!otherGroupHeader || ((_a = newMruOptions === null || newMruOptions === void 0 ? void 0 : newMruOptions.length) !== null && _a !== void 0 ? _a : 0) > 0;
  const groupLabelRenderer = groupData => {
    var _a, _b, _c;
    if (groupBy === null || groupBy === void 0 ? void 0 : groupBy.length) {
      if (groupData && ((_a = groupData[0]) === null || _a === void 0 ? void 0 : _a[groupBy])) {
        return (_b = groupData[0]) === null || _b === void 0 ? void 0 : _b[groupBy];
      }
    }
    if (groupData && ((_c = groupData[0]) === null || _c === void 0 ? void 0 : _c[MRU_GROUP_KEY])) {
      return mruTitle;
    }
    if (otherGroupHeader) {
      return otherGroupHeader;
    }
    return null;
  };
  return {
    newOptions,
    isUsingGroups,
    groupLabelRenderer
  };
};
exports.getOptionsList = getOptionsList;
const getSelectedOption = (options, itemKey, selectedOptionKey) => options.find(option => `${(0, _listboxUtils.reduceOption)(option, itemKey)}` === selectedOptionKey);
exports.getSelectedOption = getSelectedOption;
const getSelectedOptions = (options, itemKey, selectedOptionKeys) => selectedOptionKeys.map(key => options.find(option => `${(0, _listboxUtils.reduceOption)(option, itemKey)}` === key));
exports.getSelectedOptions = getSelectedOptions;
const renderSingleInputValue = args => {
  const {
    options,
    itemKey,
    inputRenderer,
    selectedOptionKey
  } = args;
  const someOption = getSelectedOption(options, itemKey, selectedOptionKey);
  if ((0, _isFunction.isFunction)(inputRenderer)) {
    return inputRenderer(someOption, selectedOptionKey);
  }
  return someOption ? someOption[inputRenderer] : '';
};
exports.renderSingleInputValue = renderSingleInputValue;
const renderMultiInputValue = args => {
  const {
    options,
    itemKey,
    inputRenderer,
    selectedOptionKeys
  } = args;
  const someOptions = getSelectedOptions(options, itemKey, selectedOptionKeys);
  let renderedValues = [];
  if ((0, _isFunction.isFunction)(inputRenderer)) {
    return inputRenderer(someOptions, selectedOptionKeys);
  }
  renderedValues = someOptions.map(someOption => (someOption === null || someOption === void 0 ? void 0 : someOption[inputRenderer]) || '');
  return renderedValues.join(', ');
};
// check if two arrays have the same values
exports.renderMultiInputValue = renderMultiInputValue;
const haveSameKeys = (keys1 = [], keys2 = []) => {
  if (keys1.length !== keys2.length) return false;
  const [sortedKeys1, sortedKeys2] = [keys1.slice().sort(), keys2.slice().sort()];
  return sortedKeys1.every((val, index) => val === sortedKeys2[index]);
};
exports.haveSameKeys = haveSameKeys;